let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hRhkr")).then(() => parcelRequire('89m2r'));